import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules"; // Rimosso Navigation
import "swiper/css";
import "swiper/css/pagination"; // Solo pagination, navigation non è più necessaria
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Card } from "react-bootstrap";

const partnershipData = [
  {
    id: 1,
    titleBody: "Partner Totem Touch",
    content:
      "Hai uno store fisico o uno spazio dove potremmo brillare insieme? Scopri i dettagli sulle commissioni.",
    company: "totemtouch",
    image: "/assets/retail-partners.png",
  },
  {
    id: 2,
    titleBody: "Content Creators",
    content:
      "Sei un creativo che ama comunicare e ispirare? Unisciti a noi per dare vita a contenuti originali.",
    company: "contentcreator",
    image: "/assets/content-creators.png",
  },
  {
    id: 3,
    titleBody: "Fashion e Design Addicted",
    content:
      "Hai talento per la moda o l'occhio giusto per lo stile? Scopri tutti i dettagli sulle commissioni.",
    company: "fashion-design",
    image: "/assets/fashion-design.png",
  },
  {
    id: 4,
    titleBody: "Tech e Innovazione",
    content:
      "Se la tecnologia è il tuo linguaggio, vogliamo parlare con te! Reinventiamo insieme il modo di vivere la moda.",
    company: "tech",
    image: "/assets/tech-innovation.png",
  },
  {
    id: 7,
    titleBody: "Community",
    content:
      "Credi nel potere delle connessioni? Hai un'identità forte e un gruppo attivo?",
    company: "communities",
    image: "/assets/community.png",
  },
];

const ReviewCarousel = () => {
  const handlePartnershipClick = (company) => {
    window.location.href = `/${company}`;
  };

  return (
    <div className="py-5" style={{ backgroundColor: '#fff' }}>
      <div className="container position-relative">
        <Swiper
          modules={[Autoplay, Pagination]} // Rimosso Navigation
          pagination={{
            clickable: true,
            bulletClass: "swiper-pagination-bullet bg-dark",
            bulletActiveClass: "swiper-pagination-bullet-active bg-dark",
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          spaceBetween={30}
          slidesPerView={3}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 25 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
          }}
          loop
          className="partnership-swiper pb-5"
        >
          {partnershipData.map((partnership) => (
            <SwiperSlide key={partnership.id}>
              <Card className="shadow-sm border-0 d-flex flex-column mx-auto" style={{ height: '600px', maxWidth: '20rem', width: '100%' }}>
                <div className="position-relative overflow-hidden" style={{ paddingTop: '80%', width: '100%' }}> {/* Rapporto 5:4 (100 / (5/4)) */}
                  <Card.Img
                    variant="top"
                    src={partnership.image}
                    alt={partnership.titleBody}
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{ objectFit: 'cover' }}
                  />
                </div>
                <Card.Body className="d-flex flex-column justify-content-between">
                  <div>
                    <Card.Title className="fw-bold fs-5 text-dark mb-2">
                      {partnership.titleBody}
                    </Card.Title>
                    <Card.Text className="text-muted small">
                      {partnership.content}
                    </Card.Text>
                  </div>
                  <Button
                    onClick={() =>
                      handlePartnershipClick(partnership.company)
                    }
                    className="w-100 mt-4 text-white"
                    style={{ height: '40px', backgroundColor: 'black', border: 'none' }}
                  >
                    Diventa un Partner
                  </Button>

                </Card.Body>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ReviewCarousel;